// src/services/gasConsumptionService.ts
import { apiClient } from './apiConfig';
import { GasConsumptionData } from '../types';

const pythonISO = (time: Date) => time.toISOString().replace(/Z$/, '+00:00');

export const getGasConsumption = async (start_time: Date, stop_time: Date, group_by: string): Promise<any> => {
  console.log('getGasConsumption', start_time, stop_time, group_by);
  const response = await apiClient.get<any>('/get-gas-consumption', {
    params: {
      start_time: pythonISO(start_time),
      stop_time: pythonISO(stop_time),
      group_by
    }
  });
  return response.data;
};
